import { create } from 'zustand';
import {
  Design,
  DesignChannelType,
  LanguageCode,
  TextToSpeechVoiceOrDefault,
  Voice
} from '../types';

export type GlobalSettings = {
  channel: DesignChannelType | null;
  language: LanguageCode | null;
  serialized: Design | null;
  ttsVoices: Partial<Record<LanguageCode, TextToSpeechVoiceOrDefault>>;
  voice: Voice | null;
};

type GlobalSettingsActions = {
  setSettings: <K extends keyof GlobalSettings>(
    updates: Pick<GlobalSettings, K>
  ) => void;
};

const useGlobalSettings = create<GlobalSettings & GlobalSettingsActions>(
  (set) => ({
    channel: null,
    language: null,
    serialized: null,
    ttsVoices: {},
    voice: null,
    setSettings: (updates) => set((state) => ({ ...state, ...updates }))
  })
);

const getGlobalSettings = () => useGlobalSettings.getState();
const setGlobalSettings = (params: GlobalSettingsActions['setSettings']) => {
  return useGlobalSettings.getState().setSettings(params);
};

export { useGlobalSettings, getGlobalSettings, setGlobalSettings };
